<img [src]="mapUrl" [width]="width()" [height]="height()" alt="Google Map" />
